import { render, staticRenderFns } from "./ModelCreateView.vue?vue&type=template&id=79729d1c"
import script from "./ModelCreateView.vue?vue&type=script&lang=js"
export * from "./ModelCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports